module.exports = "/_next/static/images/img__school-girl_desktop-b0d3019906b44dab7cf2865deb845b4c.png";